import React from "react";

const Footer = () => (
  <footer className="bg-light p-3 text-center">
    <div className="logo" />
    <p>
     
    </p>
  </footer>
);

export default Footer;
